import React, { Attributes } from "react";
import { RadioGroup, Radio } from "rsuite";
import { ButtonToolbar, Button } from "rsuite";
import Modal from 'rsuite/Modal';
import { useState } from "react";
import { Paragraph } from "@rsuite/icons";
import './EmployeeTeamsList.css';
import { EmployeeDataVM, EmployeeTeamVM } from "../../Models/ViewModels";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import {AddEditDeleteEmployeeTeam  } from "./AddEditDeleteEmployeeTeam";
import { EmployeeTeamsList } from "./EmployeeTeamsList";
import ModalFooter from "rsuite/esm/Modal/ModalFooter";
import { ModalBody } from "react-bootstrap";

type attributes = {

  action: string,
  data: EmployeeTeamVM,
  onAction: any,
  cachedData:any
}
export const EmployeeTeamModal = (props: attributes) => {
  const [open, setOpen] = React.useState(false);
  const [totalEmployeeList, setTotalEmployeeList] = useState(new EmployeeTeamVM())

  const [size, setSize] = React.useState();
  const handleOpen = (value: any) => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const onAddEmployee = (empDetail: EmployeeDataVM) => {
    handleClose()
    props.onAction(empDetail); 
  }
  const onEditEmployee = (empDetail: EmployeeDataVM) => {
    handleClose()
    props.onAction(empDetail);
 
  }
  const onDeleteEmployee = (empDetail: EmployeeDataVM) => {
    handleClose()
    props.onAction(empDetail);
  }

  if (props.action === 'edit') {
    return (
      <div className="modal-container">

        
        <i className="bi bi-pencil-fill text-warning" onClick={() => handleOpen('xs')}></i>
        <Modal size={size} open={open} onClose={handleClose} >
         
          <AddEditDeleteEmployeeTeam title='Edit Team' type={props.action} data={props.data}  cachedData={props.cachedData} onAction={onEditEmployee} />

        </Modal>

      </div>
    );

  }
   else if (props.action === 'add') {
    return (
      <div className="modal-container">
        <ButtonToolbar>
                    <Button appearance="primary" color="green" size="md" onClick={() => handleOpen('xs')}>
            <BootstrapIcon bootStrapIconName="plus" size={15} cssClasses="me-1" />Add
          </Button>
        </ButtonToolbar>


        <Modal size={size} open={open} onClose={handleClose}>

          <AddEditDeleteEmployeeTeam type='add' title='Map Employee Team' data={props.data}  cachedData={props.cachedData} onAction={onAddEmployee}
          />
          <ModalFooter>
          </ModalFooter>

        </Modal>
      </div>
    );
  }
  else {

    return (
      <div className="modal-container">

        <ButtonToolbar>


          <i className="bi bi-trash3-fill text-danger" onClick={() => handleOpen('xs')}></i>

        </ButtonToolbar>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteEmployeeTeam title='Delete Team' type={props.action} data={props.data}  cachedData={props.cachedData} onAction={onDeleteEmployee} />
        </Modal>

      </div>
    );
  }
}





